<template>
    <div>
        <app-toolbar :toolbar="toolbar"></app-toolbar>
        <v-container fluid>
        <!-- mainTable Start -->
            <v-simple-table class="mainTable" fixed-header height="75vh">
                <thead>
                    <tr>
                        <th v-show="editMode" width="20">
                        </th>
                        <th v-show="editMode" width="20">EDIT</th>
                        <th> NAME </th>
                        <th v-show="viewMode"> CREATED </th>
                        <th v-show="viewMode"> UPDATED </th>
                        <th v-show="viewMode"> CREATED BY </th>
                        <th v-show="viewMode"> UPDATED BY </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(excel, i) in CADEXCEL" :key="i">
                        <td v-show="editMode">
                            <v-checkbox v-model="excel.selected" dense></v-checkbox>
                        </td>
                        <td v-show="editMode"> 
                            <v-btn
                                fab
                                x-small
                                @click="toggleUpdateDialog(excel)"
                            >
                                <v-icon >mdi-pencil</v-icon> 
                            </v-btn>
                        </td>
                        <td> {{ excel.filename }} </td>
                        <td v-show="viewMode"> {{ formatDate(excel.created_at) }} </td>
                        <td v-show="viewMode"> {{ formatDate(excel.updated_at) }} </td>
                        <td v-show="viewMode"> {{ excel.created_by }} </td>
                        <td v-show="viewMode"> {{ excel.updated_by }} </td>
                    </tr>
                </tbody>
            </v-simple-table>
        <!-- mainTable End -->

            
        </v-container>

        <!-- Dialogs -->
        <!-- dialogStore Start -->
        <v-dialog v-model="dialogStore" max-width="300" persistent>
            <v-form id="Store" ref="Store" @submit.prevent="Store">
                <v-card>
                    <v-card-title> <span class="overline">Upload New Excel</span> </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <!-- <v-file-input
                                        outlined 
                                        dense 
                                        label="CAD Request File(Excel)"
                                        name="name" 
                                        class="required"
                                    > </v-file-input> -->
                                        <!-- :rules="rules.uniqueRemarks(REMARKS)" -->
                                <v-file-input
                                    prepend-icon=""
                                    outlined
                                    dense
                                    chips
                                    clearable
                                    v-model="fileAttachments"
                                    density="compact"
                                    label="CAD Request File(Excel)"
                                    @change="fileChange(fileAttachments)"
                                    ></v-file-input>
                                </v-col>
                            </v-row>
                            
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogStore = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogStore End -->

        <!-- dialogUpdate Update -->
        <v-dialog v-model="dialogUpdate" max-width="300" persistent>
            <v-form id="Update" ref="Update" @submit.prevent="Update">
                <v-card>
                    <v-card-title> <span class="overline">Edit File</span> </v-card-title>
                        <v-card-text>
                            <!-- <v-row>
                                <v-col cols="2">
                                    <v-icon>mdi-playlist-edit</v-icon>
                                </v-col>
                                <v-col>
                                    <span class="text-center"><b>{{tempData.filename}}</b></span>
                                </v-col>
                            </v-row> -->
                            <v-row>
                               <v-col cols="12">
                                    <v-file-input
                                        v-model="tempData.file"
                                        prepend-icon=""
                                        outlined
                                        dense
                                        chips
                                        clearable
                                        label="CAD Request File(Excel)"
                                        @change="fileChange(tempData.file)"
                                    > </v-file-input>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogUpdate = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogUpdate End -->

        <!-- dialogDelete Start -->
        <v-dialog v-model="dialogDelete" max-width="300" persistent>
            <v-form id="Delete" ref="Delete" @submit.prevent="Delete">
                <v-card>
                    <v-card-title> <span class="overline">delete</span> </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="overline font-weight-black"> Delete Selected Items? </span>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogDelete = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogDelete End -->

        <app-buttons  
            @toggleDialogDelete="toggleDialogDelete"
            @toggleDialogStore="toggleDialogStore" 
            :selectedData="selectedData"
            :floatButtons="floatButtons"
        > 
        </app-buttons>
        <app-footer :items="CADEXCEL.length"></app-footer>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ToolbarMenu from '../../modules/ToolbarMenu.vue';
import Footer from '../../modules/Footer.vue';
import FloatingButtons from '../../modules/FloatingButtons.vue';
    export default {
        components: {
            'app-toolbar': ToolbarMenu,
            'app-buttons': FloatingButtons,
            'app-footer': Footer
        },
        data: () => ({
            toolbar: {
                title: 'CAD Request Excel',
                view: true,
                back: true,
                filter: false,
                master: false,
            },

            floatButtons:{
                add: true,
                update: true,
                delete: true
            },

            tempData: {},
            
            dialogStore: false,
            dialogUpdate: false,
            dialogDelete: false,

            file: [],
            fileAttachments: {},


        }),

        computed : {
            ...mapState([
                'CADEXCEL',
                'rules',
                'viewMode',
                'editMode'
            ]),

            selectedData(){
                // this will return only the id of the selected data
                return this.CADEXCEL.filter(res => res.selected).map(res => res.id); 
            }
        },

        methods: {
            ...mapActions([
                '_getExcel',
            ]),
            fileChange(tempVariable){
                // return console.log(tempVariable)
                this.file = [];
                if(tempVariable){
                    // tempVariable.forEach(async (item) => {
                        // let splitFile = tempVariable.name.split('.')
                        // if(splitFile[splitFile.length - 1] == 'xls' || splitFile[splitFile.length - 1] == 'xlsx'){
                            // numPages = await getNumPages(tempVariable);
                            // numPages = numPages.length;
                        // }
                        const reader = new FileReader();
                        reader.readAsDataURL(tempVariable);
                        reader.onloadend = () => {
                            this.file.push({
                                data: reader.result,
                                name: tempVariable.name,
                            });
                        };
                    // })
                    console.log(this.file, 'this.file')
                }

            },

            formatDate(val){
                return new Date(val).toLocaleString('en-US', { timeZone: 'Asia/Manila', hour12: false })
            },

            toggleDialogStore(val){
                this.dialogStore = val;
            },

            Store(){
                if(this.$refs.Store.validate()){
                    const myForm = document.getElementById('Store');
                    const formdata = new FormData(myForm);
                    formdata.append("file", JSON.stringify(this.file));

                    axios({
                        method: 'POST',
                        url: '/api/cad_excel/store',
                        data: formdata
                    }).then(() => {
                        this._getExcel();
                        this.dialogStore = false;
                    })
                }
            },

            toggleUpdateDialog(item){
                if(item){
                    this.tempData = {...item};
                    console.log(this.tempData)

                    this.dialogUpdate = true;
                }else{
                    this.dialogUpdate = false;
                }
            },

            Update(){
                // return console.log(this.tempData);
                if(this.$refs.Update.validate()){
                    const myForm = document.getElementById('Update');
                    const formdata = new FormData(myForm);
                    formdata.append("file", JSON.stringify(this.file))
                    formdata.append("data", this.tempData);
                    const id = this.tempData.id

                    axios({
                        method: 'POST',
                        url: `/api/cad_excel/update/${id}`,
                        data: formdata
                    }).then(() => {
                        this._getExcel();
                        this.dialogUpdate = false;
                    })
                }
            },

            
            toggleDialogDelete(val){
                this.dialogDelete = val;
            },

            Delete(){
                axios({
                    method: 'POST',
                    url: '/api/cad_excel/delete',
                    data: {ids : this.selectedData}
                }).then(() => {
                    this._getExcel();
                    this.dialogDelete = false;
                })
            }
        },

        mounted() {
            this._getExcel();
        },

        watch:{
            dialogStore(value){
                if( ! value ) this.$refs.Store.reset();
            },

            dialogUpdate(value){
                if( ! value ) this.$refs.Update.reset();
            },

        }
    }
</script>

<style scoped>


</style>